<template>
  <div
    v-tooltip="{
      content: tooltipText,
      placement: 'bottom',
      onShow: () => !(bookmarkingDisabled || draggingIsOn) && !isMobile,
    }"
    class="square-icon-wrap h-w-32 header-icon group"
    :class="{ bookmarked: bookmarked, 'disabled-item': bookmarkingDisabled }"
    @click="toggleBookmark(resource, type)"
  >
    <em
      :style="iconStyle"
      :class="[
        { disabled: bookmarkingDisabled },
        { 'group-hover:bg-icon-hover': !isFavourite(resource.id, type) && !bookmarkingDisabled },
      ]"
      class="bookmark-header-icon custom-icons"
    />
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import BookmarkMixin from '@/mixins/BookmarkMixin';
import { ResourceType } from '../../types/resources';
import useGetBookmarkTooltipText from '@/utilities/composables/useGetBookmarkTooltipText';
import useBoardEmbed from '@/boards/composables/useBoardEmbed';

export default {
  name: 'BookmarkHeaderButton',

  mixins: [customIconsMixin, BookmarkMixin],

  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
  },

  setup() {
    const { getTooltipText } = useGetBookmarkTooltipText();
    const { inEpicBoard } = useBoardEmbed();

    return {
      getTooltipText,
      inEpicBoard,
    };
  },

  computed: {
    bookmarked() {
      return this.isFavourite(this.resource.id, this.type);
    },

    iconStyle() {
      const iconBackground = this.bookmarkingDisabled
        ? 'var(--inactiveElementIcon)'
        : 'var(--iconDefault)';
      return {
        ...this.getCustomIconStyle(
          this.iconPath(this.isFavourite(this.resource.id, this.type) ? 'star-active' : 'star')
        ),
        background: this.isFavourite(this.resource.id, this.type) ? '#FEC84B' : iconBackground,
      };
    },

    page() {
      return this.$store.getters.getPage;
    },

    board() {
      return this.$store.getters.currentBoard;
    },

    card() {
      return this.$store.getters.getCardById(this.id);
    },

    view() {
      return this.$store.getters.getSelectedView;
    },

    member() {
      return this.$store.getters.getMemberById(this.id);
    },

    noteTemplate() {
      return this.$store.getters.getNoteTemplates[this.id] ?? {};
    },

    resource() {
      switch (this.type) {
        case ResourceType.Sprint:
        case ResourceType.Board:
          return this.board;
        case ResourceType.Page:
          return this.page;
        case ResourceType.Card:
        case ResourceType.Epic:
          return this.card;
        case ResourceType.View:
          return this.view;
        case ResourceType.Member:
          return this.member;
        case ResourceType.NoteTemplate:
          return this.noteTemplate;
        default:
          return null;
      }
    },
    tooltipText() {
      return this.getTooltipText(this.bookmarked, this.board.title, this.type, this.board?.state);
    },
  },
};
</script>

<style lang="scss">
.header-icon {
  .bookmark-header-icon {
    height: 20px;
    width: 20px;
    @apply bg-icon-default;
  }

  &.disabled-item {
    cursor: default;
    &:hover {
      background: transparent;
    }
  }
}
</style>
